import { render, staticRenderFns } from "./drawpigplay.vue?vue&type=template&id=4589d35c&scoped=true&"
import script from "./drawpigplay.vue?vue&type=script&lang=js&"
export * from "./drawpigplay.vue?vue&type=script&lang=js&"
import style0 from "./drawpigplay.vue?vue&type=style&index=0&id=4589d35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589d35c",
  null
  
)

export default component.exports